import Vue from 'vue';
import ToastView from './index.vue';

const Toast = Vue.extend(ToastView);

function toast (message, duration = 3000) {
  let instance = new Toast();

  instance.message = message;

  instance.close = () => {
    document.body.removeChild(instance.$el);
    instance.$destroy();
    instance = null;
  };

  instance.$mount();
  document.body.appendChild(instance.$el);

  setTimeout(() => {
    instance.close();
  }, duration);

  return instance;
}

toast.success = (message, duration) => toast(message, duration);

export default toast;



// WEBPACK FOOTER //
// ./src/components/common/toast/index.js